import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    openReport: [
        {
            id: 1,
            reportNumber: '#10',
            reported: 'James Whitaker',
            reportedBy: 'James Whitaker',
            reason: ['NOT_REAL_INVESTOR', 'Not a real founder'],
            reportedDate: 'May 2, 2024',
            type: 'VC',
            status: 'Open',
        },
        {
            id: 2,
            reportNumber: '#9',
            reported: 'Olivia Hastings',
            reportedBy: 'Olivia Hastings',
            reason: ['Not real founder'],
            reportedDate: 'May 3, 2024',
            type: 'Angel',
            status: 'Open',
        },
        {
            id: 3,
            reportNumber: '#8',
            reported: 'Brandon Cole',
            reportedBy: 'Brandon Cole',
            reason: ['INAPPROPRIATE_MESSAGES'],
            reportedDate: 'April 29, 2024',
            type: 'Founder',
            status: 'Open',
        },
        {
            id: 4,
            reportNumber: '#520',
            reported: 'Sophia Klein',
            reportedBy: 'Sophia Klein',
            reason: ['FAKE_PROFILE_SPAM', 'INAPPROPRIATE_MESSAGES'],
            reportedDate: 'April 17, 2024',
            type: 'Founder',
            status: 'Open',
        },
        {
            id: 5,
            reportNumber: '#6',
            reported: 'Ethan Morales',
            reportedBy: 'Ethan Morales',
            reason: ['INAPPROPRIATE_BIO', 'Not real founder'],
            reportedDate: 'May 16, 2024',
            type: 'VC',
            status: 'Open',
        },
        {
            id: 6,
            reportNumber: '#5',
            reported: 'Madison Lee',
            reportedBy: 'Madison Lee',
            reason: ['INAPPROPRIATE_MESSAGES'],
            reportedDate: 'September 1, 2024',
            type: 'Angel',
            status: 'Open',
        },
        {
            id: 7,
            reportNumber: '#4',
            reported: 'Dylan Prescott',
            reportedBy: 'Dylan Prescott',
            reason: ['UNDERAGE_USER'],
            reportedDate: 'April 17, 2024',
            type: 'Accelerator',
            status: 'Open',
        },
        {
            id: 8,
            reportNumber: '#3',
            reported: 'Isabella Novak',
            reportedBy: 'Isabella Novak',
            reason: ['NOT_REAL_INVESTOR'],
            reportedDate: 'April 21, 2024',
            type: 'VC',
            status: 'Open',
        },
        {
            id: 9,
            reportNumber: '#2',
            reported: 'Marcus Bell',
            reportedBy: 'Marcus Bell',
            reason: ['OFFLINE_BEHAVIOR', 'FAKE_PROFILE_SPAM', 'UNDERAGE_USER'],
            reportedDate: 'April 29, 2024',
            type: 'Accelerator',
            status: 'Open',
        },
        {
            id: 10,
            reportNumber: '#1',
            reported: 'Chloe Ramsey',
            reportedBy: 'Chloe Ramsey',
            reason: ['UNDERAGE_USER'],
            reportedDate: 'July 13, 2024',
            type: 'Angel',
            status: 'Open',
        }
    ],
    closeReport: [
        {
            id: 1,
            reportNumber: '#10',
            reported: 'James Whitaker',
            reportedBy: 'Bar tov',
            reason: ['NOT_REAL_INVESTOR', 'Not real founder'],
            reportedDate: 'May 2, 2024',
            closedDate: 'May 2, 2024',
            status: 'Ignored',
            type: 'VC'
        },
        {
            id: 2,
            reportNumber: '#9',
            reported: 'Olivia Hastings',
            reportedBy: 'Olivia Hastings',
            reason: ['Not real founder'],
            reportedDate: 'May 3, 2024',
            closedDate: 'May 3, 2024',
            status: 'Suspended',
            type: 'Angel'
        },
        {
            id: 3,
            reportNumber: '#8',
            reported: 'Brandon Cole',
            reportedBy: 'Brandon Cole',
            reason: ['INAPPROPRIATE_MESSAGES'],
            reportedDate: 'April 29, 2024',
            closedDate: 'April 29, 2024',
            status: 'Ignored',
            type: 'Founder'
        },
        {
            id: 4,
            reportNumber: '#520',
            reported: 'Sophia Klein',
            reportedBy: 'Sophia Klein',
            reason: ['FAKE_PROFILE_SPAM', 'INAPPROPRIATE_MESSAGES'],
            reportedDate: 'April 17, 2024',
            closedDate: 'April 17, 2024',
            status: 'Ignored',
            type: 'Founder'
        },
        {
            id: 5,
            reportNumber: '#6',
            reported: 'Ethan Morales',
            reportedBy: 'Ethan Morales',
            reason: ['INAPPROPRIATE_BIO', 'NOT_REAL_INVESTOR'],
            reportedDate: 'May 16, 2024',
            closedDate: 'May 16, 2024',
            status: 'Ignored',
            type: 'VC'
        },
        {
            id: 6,
            reportNumber: '#5',
            reported: 'Madison Lee',
            reportedBy: 'Madison Lee',
            reason: ['INAPPROPRIATE_MESSAGES'],
            reportedDate: 'September 1, 2024',
            closedDate: 'September 1, 2024',
            status: 'Ignored',
            type: 'Angel'
        },
        {
            id: 7,
            reportNumber: '#4',
            reported: 'Dylan Prescott',
            reportedBy: 'Dylan Prescott',
            reason: ['UNDERAGE_USER'],
            reportedDate: 'April 17, 2024',
            closedDate: 'April 17, 2024',
            status: 'Suspended',
            type: 'Accelerator'
        },
        {
            id: 8,
            reportNumber: '#3',
            reported: 'Isabella Novak',
            reportedBy: 'Isabella Novak',
            reason: ['Not real founder'],
            reportedDate: 'April 21, 2024',
            closedDate: 'April 21, 2024',
            status: 'Ignored',
            type: 'VC'
        },
        {
            id: 9,
            reportNumber: '#2',
            reported: 'Marcus Bell',
            reportedBy: 'Marcus Bell',
            reason: ['OFFLINE_BEHAVIOR', 'FAKE_PROFILE_SPAM', 'UNDERAGE_USER'],
            reportedDate: 'April 29, 2024',
            closedDate: 'April 29, 2024',
            status: 'Ignored',
            type: 'Accelerator'
        },
        {
            id: 10,
            reportNumber: '#1',
            reported: 'Chloe Ramsey',
            reportedBy: 'Chloe Ramsey',
            reason: ['UNDERAGE_USER'],
            reportedDate: 'July 13, 2024',
            closedDate: 'July 13, 2024',
            status: 'Suspended',
            type: 'Angel'
        }
    ],
    singleReport: {
        reportType: 'Open',
        date: 'April 12, 2024',
        reported: {
            name: 'Ethan Brooks',
            userType: 'VC',
            plan: "Active",
            planName: 'Monthly Plan',
        }, reportedBy: {
            name: 'Olivia Hastings',
            userType: 'Founder',
            plan: 'Active'
        },
        reason: ['NOT_REAL_INVESTOR', 'INAPPROPRIATE_MESSAGES'],
        numberofReport: 3
    }
}

const reportSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        setOpenReport: (state, action) => {
            state.openReport = action.payload;
        },
        setCloseReport: (state, action) => {
            state.closeReport = action.payload;
        },
        setSingleReport: (state, action) => {
            state.singleReport = action.payload;
        },
    },
});

export const {
    setOpenReport,
    setCloseReport,
    setSingleReport
} = reportSlice.actions;

export default reportSlice.reducer;